import React from "react";
import Reveal from "./Reveal";

const quotes = [
  {
    quote:
      "Nike has always been rooted in disruptive yet consistent behaviour, setting the tone for modern marketing and culture. Working with Mehak gave us the confidence to step into a new wave of the digital era, especially with the rise of AI, and shaped how we position emerging talent not just as creatives but as leaders within their own lane. I highly recommend Mehak.",
    name: "Gina Peters",
    role: "Senior Head of Retail Marketing, Nike London",
  },
  {
    quote:
      "At Cartier, branding has always been about more than visibility, it's about premium positioning, storytelling and knowing exactly who you are speaking to. Working with Mehak strengthened how we translate that level of brand clarity into leadership, especially in how we position teams to lead with a strong understanding of client relationships and brand experience at every touchpoint. Her training is exceptional and executed clearly.",
    name: "David White",
    role: "Client Experience, Cartier",
  },
  {
    quote:
      "I've experienced so much since starting and you're a huge part of that. Your power and elegant strength is a vehicle through which the divine works. Those who need to will find you, and I certainly do.",
    name: "Andrea Smith",
    role: "Na'Phori Living",
  },
  {
    quote:
      "They get branding, not just content. The first thirty days felt like a repositioning, not a posting schedule.",
    name: "Chad Morris",
    role: "Founder, London Lighting",
  },
  {
    quote:
      "We had authority but no monetisation path. Little Things turned an engaged audience into actual revenue.",
    name: "Nevzet Altinisik",
    role: "Founder, UkFilmWork",
  },
];

const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-28 lg:py-36 bg-[var(--lt-cream)]/50 border-t border-b border-[var(--lt-line)]"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow text-center mb-12">/ Testimonials</p>
        </Reveal>

        <div className="grid grid-cols-12 gap-8 lg:gap-12">
          {quotes.map((q, i) => (
            <Reveal
              key={q.name}
              delay={i * 120}
              className="col-span-12 md:col-span-6 lg:col-span-4"
              data-testid={`testimonial-${i}`}
            >
              <div className="h-full border-t border-[var(--lt-charcoal)] pt-6">
                <p
                  className="font-display italic text-[var(--lt-charcoal)] leading-[1.35] mb-10"
                  style={{ fontSize: "clamp(1.2rem, 1.6vw, 1.7rem)", fontWeight: 400 }}
                >
                  “{q.quote}”
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-[var(--lt-charcoal)] font-medium">
                    {q.name}
                  </span>
                  <span className="text-xs uppercase tracking-[0.18em] text-[var(--lt-bark)]/70">
                    {q.role}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
